import React from "react";

export const HarmonyLogoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 240 240"
    fill="none"
    role="img"
    aria-label="Harmony logo"
    {...props}
  >
    <path
      d="M78.5455 187.455C78.5455 203.119 65.8467 215.818 50.1818 215.818C34.517 215.818 21.8182 203.119 21.8182 187.455C21.8182 172.035 34.1228 159.488 49.4489 159.099L50.1818 159.091L50.7422 159.076C56.5067 158.784 61.0909 154.019 61.0909 148.182C61.0909 142.345 56.5067 137.579 50.7422 137.288L50.1818 137.273L48.8864 137.29C21.7704 137.977 2.07553e-07 160.173 0 187.455C0 215.169 22.4672 237.636 50.1818 237.636C77.8965 237.636 100.364 215.169 100.364 187.455C100.364 181.43 95.4795 176.545 89.4546 176.545C83.4297 176.545 78.5455 181.43 78.5455 187.455Z"
      fill="currentColor"
    />
    <path
      d="M161.455 52.1818C161.455 36.517 174.153 23.8182 189.818 23.8182C205.483 23.8182 218.182 36.517 218.182 52.1818C218.182 67.6016 205.877 80.1482 190.551 80.5369L189.818 80.5454L189.258 80.5604C183.493 80.8521 178.909 85.6176 178.909 91.4545C178.909 97.2915 183.493 102.057 189.258 102.349L189.818 102.364L191.114 102.347C218.23 101.659 240 79.4633 240 52.1818C240 24.4672 217.533 2 189.818 2C162.103 2 139.636 24.4672 139.636 52.1818C139.636 58.2067 144.52 63.0909 150.545 63.0909C156.57 63.0909 161.455 58.2067 161.455 52.1818Z"
      fill="currentColor"
    />
    <path
      d="M50.1818 2C77.9861 2 100.364 24.7121 100.364 52.527V108.909H139.636V91.4545C139.636 85.4296 144.521 80.5454 150.545 80.5454C156.57 80.5454 161.455 85.4296 161.455 91.4545V108.909H168C174.025 108.909 178.909 113.793 178.909 119.818C178.909 125.843 174.025 130.727 168 130.727H161.455V187.109C161.455 203.054 174.243 215.818 189.818 215.818C205.393 215.818 218.182 203.054 218.182 187.109C218.181 171.165 205.393 158.403 189.818 158.403C183.794 158.403 178.91 153.518 178.909 147.494C178.909 141.469 183.793 136.584 189.818 136.584C217.622 136.584 240 159.295 240 187.109C240 214.924 217.622 237.636 189.818 237.636C162.014 237.636 139.636 214.924 139.636 187.109V130.727H100.364V148.182C100.364 154.207 95.4795 159.091 89.4545 159.091C83.4296 159.091 78.5455 154.207 78.5455 148.182V130.727H72C65.9751 130.727 61.0909 125.843 61.0909 119.818C61.0909 113.793 65.9751 108.909 72 108.909H78.5455V52.527C78.5455 36.5819 65.757 23.8182 50.1818 23.8182C34.6066 23.8182 21.8182 36.5819 21.8182 52.527C21.8185 68.4717 34.6069 81.2336 50.1818 81.2336C56.2065 81.2336 61.0905 86.1182 61.0909 92.1427C61.0909 98.1677 56.2067 103.052 50.1818 103.052C22.3778 103.052 0.000361579 80.3416 0 52.527C0 24.7121 22.3775 2 50.1818 2Z"
      fill="currentColor"
    />
  </svg>
);

export const HarmonyLogoColoredIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.8182 26.6111C12.8182 28.6055 11.2308 30.2222 9.27272 30.2222C7.31462 30.2222 5.72727 28.6055 5.72727 26.6111C5.72727 24.648 7.26534 23.0506 9.1811 23.0011L9.27272 23L9.34277 22.9981C10.0633 22.961 10.6364 22.3543 10.6364 21.6111C10.6364 20.868 10.0633 20.2613 9.34277 20.2241L9.27272 20.2222L9.11079 20.2244C5.7213 20.3119 3 23.1378 3 26.6111C3 30.1396 5.80839 33 9.27272 33C12.737 33 15.5454 30.1396 15.5454 26.6111C15.5454 25.8441 14.9349 25.2222 14.1818 25.2222C13.4287 25.2222 12.8182 25.8441 12.8182 26.6111Z"
      fill="url(#paint0_linear_3963_17992)"
    />
    <path
      d="M23.1818 9.38888C23.1818 7.39452 24.7692 5.77778 26.7273 5.77778C28.6854 5.77778 30.2727 7.39452 30.2727 9.38888C30.2727 11.352 28.7347 12.9494 26.8189 12.9989L26.7273 13L26.6572 13.0019C25.9367 13.039 25.3636 13.6457 25.3636 14.3889C25.3636 15.132 25.9367 15.7387 26.6572 15.7759L26.7273 15.7778L26.8892 15.7756C30.2787 15.6881 33 12.8622 33 9.38888C33 5.8604 30.1916 3 26.7273 3C23.263 3 20.4546 5.8604 20.4546 9.38888C20.4546 10.1559 21.0651 10.7778 21.8182 10.7778C22.5713 10.7778 23.1818 10.1559 23.1818 9.38888Z"
      fill="url(#paint1_linear_3963_17992)"
    />
    <path
      d="M9.27272 3C12.7483 3 15.5454 5.89158 15.5454 9.43283V16.6111H20.4545V14.3889C20.4545 13.6218 21.065 13 21.8182 13C22.5713 13 23.1818 13.6218 23.1818 14.3889V16.6111H24C24.7531 16.6111 25.3636 17.2329 25.3636 18C25.3636 18.7671 24.7531 19.3889 24 19.3889H23.1818V26.5672C23.1818 28.5972 24.7803 30.2222 26.7272 30.2222C28.6741 30.2222 30.2727 28.5972 30.2727 26.5672C30.2726 24.5371 28.6741 22.9124 26.7272 22.9124C25.9742 22.9124 25.3637 22.2905 25.3636 21.5235C25.3636 20.7564 25.9741 20.1346 26.7272 20.1346C30.2027 20.1346 32.9999 23.0259 33 26.5672C33 30.1084 30.2028 33 26.7272 33C23.2517 33 20.4545 30.1084 20.4545 26.5672V19.3889H15.5454V21.6111C15.5454 22.3782 14.9349 23 14.1818 23C13.4287 23 12.8182 22.3782 12.8182 21.6111V19.3889H12C11.2469 19.3889 10.6364 18.7671 10.6364 18C10.6364 17.2329 11.2469 16.6111 12 16.6111H12.8182V9.43283C12.8182 7.40279 11.2196 5.77778 9.27272 5.77778C7.32583 5.77778 5.72727 7.40279 5.72727 9.43283C5.72731 11.4628 7.32585 13.0876 9.27272 13.0876C10.0258 13.0876 10.6363 13.7095 10.6364 14.4765C10.6364 15.2436 10.0258 15.8654 9.27272 15.8654C5.79722 15.8654 3.00005 12.974 3 9.43283C3 5.89158 5.79719 3 9.27272 3Z"
      fill="url(#paint2_linear_3963_17992)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3963_17992"
        x1="6.81454"
        y1="23.141"
        x2="13.7861"
        y2="30.7463"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0788211" stopColor="#6B3ED7" />
        <stop offset="1" stopColor="#B272EB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3963_17992"
        x1="29.1855"
        y1="12.859"
        x2="22.2139"
        y2="5.25367"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.0788211" stopColor="#6B3ED7" />
        <stop offset="1" stopColor="#B272EB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3963_17992"
        x1="5.35295"
        y1="5.11971"
        x2="31.5124"
        y2="30.8025"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4E2ABD" />
        <stop offset="0.197115" stopColor="#6B3ED7" />
        <stop offset="0.495192" stopColor="#BF7FF9" />
        <stop offset="0.798077" stopColor="#6A3FCC" />
        <stop offset="1" stopColor="#4E2ABD" />
      </linearGradient>
    </defs>
  </svg>
);